import './layout.css'

export function ATScreen (props) {

    return (
        <div className="at-screen">
            {props.children}
        </div>
    )
}